const COMMON: any = {
  currency : true,
  status : true,
  date : true,
};

export default (ctx: any, data: any = {}) => {
  if (!COMMON[(ctx as any).param])
    return;

  //TODO: fix this ASAP
  const isReport = ctx.isReport 
    ? ctx.isReport
    : () => false;

  if(!ctx.isReport) {
    console.error('isReport method not found. now using stub');
  }

  const {commit} = ctx.$store;
  const params = {
    name: data.param || (ctx as any).param,
    value: data.value || data.value === '' 
      ? data.value
      : (ctx as any).value
  };

  commit('tableQuery', {
    grouping: ctx.$route.params.type as any,
    notSetToLocalStorage: isReport(),
    ...params,
  });

    commit('dashboardQuery', {
    grouping: ctx.$route.params.type as any,
    notSetToLocalStorage: isReport(),
    ...params,
  });
}
 